import { render } from "./AutocompleteRadioV2.vue?vue&type=template&id=3509b76d&scoped=true"
import script from "./AutocompleteRadioV2.vue?vue&type=script&lang=js"
export * from "./AutocompleteRadioV2.vue?vue&type=script&lang=js"

import "./AutocompleteRadioV2.vue?vue&type=style&index=0&id=3509b76d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3509b76d"

export default script